<template>
  <div>
    <heading :helpInfo="sidebarCard">
      {{ $t("sidebar.instructionCategory") }}
    </heading>

    <instructionCategoryTable />
  </div>
</template>

<script>
import instructionCategoryTable from "@/views/operatingInstruction/instructionCategoryTable.vue";
import * as sidebarTextDE from "../../components/api/content/sidebarText-de.json";
import * as sidebarTextEN from "../../components/api/content/sidebarText-en.json";
export default {
  name: "instructionCategory",
  components: { instructionCategoryTable },
  computed: {
    sidebarCard() {
      if (this.$i18n.locale == "de") {
        return sidebarTextDE.default.instructionCategory;
      } else if (this.$i18n.locale == "en") {
        return sidebarTextEN.default.instructionCategory;
      }
      return sidebarTextDE.default.instructionCategory;
    },
  },
};
</script>
